import ApiService from "@/core/services/api.service";

const BASE_RESOURCE = "/statistics/recipients";

const StatisticsRecipientsService = {
  list() {
    return ApiService.query(BASE_RESOURCE);
  },

  get(id) {
    return ApiService.query(BASE_RESOURCE, id);
  },

  create(payload) {
    return ApiService.post(BASE_RESOURCE, payload);
  },

  update(id, payload) {
    return ApiService.put(`${BASE_RESOURCE}/${id}`, payload);
  },

  send(id) {
    return ApiService.post(`${BASE_RESOURCE}/${id}/send`);
  },

  delete(id) {
    return ApiService.delete(`${BASE_RESOURCE}/${id}`);
  }
};

export default StatisticsRecipientsService;
